import React, { Component } from 'react';
import selfiePlaceholder from '../../assets/selfie.png';
import ImageUpload from '../../components/ImageUpload';
import AuthService from '../../services/api/auth';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withAlert } from 'react-alert';
import LoadingModal from '../../components/LoadingModal';
import ErrorList from '../../components/ErrorList';
import ImageTools from '../../services/helper/ImageTools';
import Helper from '../../helpers';
import { setMediaDevicesEnabled, setModalOpeningCount } from '../../redux/application/actions';
import {
    isMediaDevicesEnabledSelector,
    modalOpeningCountSelector,
    requiresPermissionRequestSelector,
} from '../../redux/application/selector';
import Bugsnag from '@bugsnag/js';
import DesktopCameraEnabled from '../../components/DesktopCameraEnabled';
import BrowserService from '../../services/helper/browserService';
const isDesktop = !BrowserService.isMobileOrTabled();

class SelfieScreen extends Component {
    constructor(props) {
        super(props);
        this.state = { picture: null, loading: false, errors: [] };
        this.onDrop = this.onDrop.bind(this);
    }

    componentDidMount() {
        const { setStep, requiresPermissionRequest } = this.props;
        // this is a new session, remove cookie;
        setStep('SELFIE');
        Helper.getMedias(requiresPermissionRequest);
    }

    onDrop(picture) {
        this.setState({
            picture,
        });
    }

    backToStatus = () => {
        const { onSetMediaDevicesEnabled } = this.props;
        onSetMediaDevicesEnabled(false);
        if (window.VULOG_CONFIG && window.VULOG_CONFIG.FORCE_TO_TAKE_PHOTO) {
            this.props.history.push('/register/status');
        }
    };

    updateComponent = () => {
        const { onSetMediaDevicesEnabled } = this.props;
        onSetMediaDevicesEnabled(true);
        Helper.updateComponent();
    };

    cancel() {
        this.setState({ picture: null });
        this.imagePicker.reset();
        AuthService.getAccountStatus().then(response => {
            response.steps.forEach((entry, i) => {
                if (entry.path === this.props.location.pathname) {
                    if (entry.back) {
                        this.props.history.push(entry.back);
                    } else {
                        const lastScreen = response.steps[i - 1];
                        if (lastScreen && lastScreen.path) {
                            this.props.history.push(lastScreen.path);
                        }
                    }
                }
            });
        });
    }

    async savePhoto() {
        this.setState({
            loading: true,
        });

        let data = new FormData();
        const imageTool = new ImageTools();

        if (imageTool) {
            let resizedImage = await imageTool.resize(this.state.picture, { width: 1000, height: 1000 });
            data.append('selfie', resizedImage);
        } else {
            data.append('selfie', this.state.picture);
        }

        AuthService.saveSelfie(data)
            .then(() => {
                this.setState({
                    loading: false,
                });

                AuthService.getAccountStatus()
                    .then(response => {
                        if (response.next === null) {
                            this.props.history.push('/status');
                        } else {
                            this.props.history.push(response.next);
                        }
                    })
                    .catch(e => {
                        Bugsnag.notify(e.data);
                    });
            })
            .catch(response => {
                if (response && response.data && response.data.message) {
                    Bugsnag.notify(response.data);
                    this.setState({
                        errors: [response.data.message],
                        loading: false,
                    });
                } else if (response && response.message) {
                    Bugsnag.notify(response);
                    this.setState({
                        errors: [response.message],
                        loading: false,
                    });
                } else {
                    this.setState({
                        errors: ['DEFAULT_ERROR_MESSAGE'],
                        loading: false,
                    });
                }
            });
    }

    render() {
        return (
            <div className="container-fluid wrapper">
                <div className="d-flex flex-column justify-content-center full-height">
                    <div>
                        <h3 className="page__title">{window.VULOG_TRANSLATE('TAKE A SELFIE')}</h3>
                        <p className={'page__subtitle'}>{window.VULOG_TRANSLATE('SELFIE_SUBTITLE')}</p>
                        {window.VULOG_CONFIG && window.VULOG_CONFIG.ERROR_DISPLAY_TOP && (
                            <ErrorList errors={this.state.errors} />
                        )}
                        <div
                            className="image-upload__container selfie d-flex flex-column justify-content-center"
                            style={{ backgroundImage: `url(${window.VULOG_CONFIG.SELFIE_PLACEHOLDER_IMAGE})` }}
                        >
                            <ImageUpload
                                isSelfie={true}
                                imageExtension={['png', 'jpg', 'PNG', 'JPG']}
                                ref={ref => (this.imagePicker = ref)}
                                placeholder={selfiePlaceholder}
                                onChange={this.onDrop.bind(this)}
                                isMediaDevicesEnabled={this.props.isMediaDevicesEnabled}
                                modalOpeningCount={this.props.modalOpeningCount}
                                onSetModalOpeningCount={this.props.onSetModalOpeningCount}
                                requiresPermissionRequest={this.props.requiresPermissionRequest}
                            />
                        </div>
                    </div>
                    {!this.state.picture && (
                        <>
                            <DesktopCameraEnabled>
                                <div className="d-flex flex-row">
                                    <button
                                        className="btn btn-primary btn-block full"
                                        onClick={() => this.imagePicker.triggerFileUpload()}
                                        id={'imageUploadButton'}
                                    >
                                        <i className="material-icons va-middle reg">photo_camera</i>
                                    </button>
                                </div>
                            </DesktopCameraEnabled>
                            {isDesktop && (
                                <div className="d-flex flex-row">
                                    <button
                                        className="btn btn-secondary btn-block full file-upload-button"
                                        onClick={() => this.imagePicker.openFileInput()}
                                        id={'imageUploadButton'}
                                    >
                                        <i className="material-icons va-middle reg">upload</i>
                                    </button>
                                </div>
                            )}
                        </>
                    )}

                    {this.state.picture && (
                        <div className="d-flex flex-row">
                            <button
                                id={'btnBack'}
                                className="btn btn-primary flex-grow-1 flex-shrink-0 mr-2"
                                onClick={this.cancel.bind(this)}
                            >
                                <i className="material-icons va-middle reg">keyboard_arrow_left</i>
                                {window.VULOG_TRANSLATE('Back')}
                            </button>
                            <button
                                className="btn btn-primary flex-grow-1 flex-shrink-0 ml-2"
                                onClick={this.savePhoto.bind(this)}
                            >
                                {window.VULOG_TRANSLATE('Next')}
                                <i className="material-icons va-middle reg">keyboard_arrow_right</i>
                            </button>
                        </div>
                    )}
                    <LoadingModal loading={this.state.loading} />
                    <button id={'backBtn'} style={{ display: 'none' }} onClick={this.backToStatus} />
                    <button id={'stopTrackBtn'} style={{ display: 'none' }} onClick={this.updateComponent} />

                    {!window.VULOG_CONFIG.ERROR_DISPLAY_TOP && (
                        <ErrorList errors={this.state.errors} hide={this.state.errors.length === 0} />
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    isMediaDevicesEnabled: isMediaDevicesEnabledSelector(state),
    modalOpeningCount: modalOpeningCountSelector(state),
    requiresPermissionRequest: requiresPermissionRequestSelector(state),
});

const mapDispatchToProps = dispatch => ({
    onSetMediaDevicesEnabled: bindActionCreators(setMediaDevicesEnabled, dispatch),
    onSetModalOpeningCount: bindActionCreators(setModalOpeningCount, dispatch),
});

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(SelfieScreen));
